// extracted by mini-css-extract-plugin
module.exports = {"deleted":"KpiDeleted_deleted__3TU_o","title":"KpiDeleted_title__1zhJZ","icon":"KpiDeleted_icon__1FWA5","rotated":"KpiDeleted_rotated__3-3Zk"};